<template>
	
<div>
	<div class="row mb-3 row-deck row-cards">
	    <div v-if="data.isBlockBar" class="col-sm-6 col-lg-3">
	        <div class="card">
	            <div class="card-body">
	                <div class="d-flex align-items-center">
	                    <div class="subheader">Total Posts</div>
	                    <div class="ms-auto lh-1">
	                        <div class="dropdown">
	                            <a class="dropdown-toggle text-muted" href="javascript:void(0)" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
	                            	<span>{{ total_posts_label }}</span>
	                            </a>
	                            <div class="dropdown-menu dropdown-menu-end">
	                                <a :class="getPostTotalactiveClass(1)" href="javascript:void(0)" v-on:click="getPostTotaltoggleActive(1)">All Posts</a>
	                                <a :class="getPostTotalactiveClass(2)" href="javascript:void(0)" v-on:click="getPostTotaltoggleActive(2)">Last 7 days</a>
	                                <a :class="getPostTotalactiveClass(3)" href="javascript:void(0)" v-on:click="getPostTotaltoggleActive(3)">Last 30 days</a>
	                                <a :class="getPostTotalactiveClass(4)" href="javascript:void(0)" v-on:click="getPostTotaltoggleActive(4)">Last 3 months</a>
	                            </div>
	                        </div>
	                    </div>
	                </div>
	                <div class="d-flex align-items-baseline">
	                    <div class="h1 mb-0 me-2">{{ total_posts }}</div>
	                    <div class="me-auto">
	                        <span v-if="total_posts_latest > 0" class="text-green d-inline-flex align-items-center lh-1">	                        	
	                            +{{ total_posts_latest }} 
	                            <svg xmlns="http://www.w3.org/2000/svg" class="icon ms-1" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><polyline points="3 17 9 11 13 15 21 7" /><polyline points="14 7 21 7 21 14" /></svg>
	                        </span>
	                        <span v-else class="text-yellow d-inline-flex align-items-center lh-1">
	                            0 
	                            <svg xmlns="http://www.w3.org/2000/svg" class="icon ms-1" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><line x1="5" y1="12" x2="19" y2="12" /></svg>
	                        </span>
	                    </div>
	                </div>
	            </div>
	        </div>
	    </div>

	    <div v-if="data.isBlockBar" class="col-sm-6 col-lg-3">
	        <div class="card">
	            <div class="card-body">
	                <div class="d-flex align-items-center">
	                    <div class="subheader">Total Post Views</div>
	                    <div class="ms-auto lh-1">
	                        <div class="dropdown">
	                            <a class="dropdown-toggle text-muted" href="#" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">All</a>
	                            <div class="dropdown-menu dropdown-menu-end">
	                                <a :class="getTotalViewactiveClass(1)" href="javascript:void(0)" v-on:click="getTotalViewtoggleActive(1)">All</a>
	                                <a :class="getTotalViewactiveClass(2)" href="javascript:void(0)" v-on:click="getTotalViewtoggleActive(2)">Last 30 days</a>
	                                <a :class="getTotalViewactiveClass(3)" href="javascript:void(0)" v-on:click="getTotalViewtoggleActive(3)">Last 3 months</a>
	                            </div>
	                        </div>
	                    </div>
	                </div>
	                <div class="d-flex align-items-baseline">
	                    <div class="h1 mb-3 me-2">{{ total_views }}</div>
	                    <div class="me-auto">
	                        <span v-if="total_views_latest > 0" class="text-yellow d-inline-flex align-items-center lh-1">
	                            +{{ total_views_latest }}  
	                            <svg xmlns="http://www.w3.org/2000/svg" class="icon ms-1" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><line x1="5" y1="12" x2="19" y2="12" /></svg>
	                        </span>
	                    </div>
	                </div>
	            </div>
	        </div>
	    </div>

	    <div v-if="data.isBlockBar" class="col-sm-6 col-lg-3">
	        <div class="card">
	            <div class="card-body">
	                <div class="d-flex align-items-center">
	                    <div class="subheader">Total Login</div>
	                    <div class="ms-auto lh-1">
	                        <div class="dropdown">
	                            <a class="dropdown-toggle text-muted" href="#" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">All</a>
	                            <div class="dropdown-menu dropdown-menu-end">
	                            	<a :class="getTotalLoginActiveClass(1)" href="javascript:void(0)" v-on:click="getTotalLoginToggleActive(1)">All</a>
	                            	<a :class="getTotalLoginActiveClass(2)" href="javascript:void(0)" v-on:click="getTotalLoginToggleActive(2)">Last 30 days</a>
	                            	<a :class="getTotalLoginActiveClass(3)" href="javascript:void(0)" v-on:click="getTotalLoginToggleActive(3)">Last 3 months</a>
	                            </div>
	                        </div>
	                    </div>
	                </div>
	                <div class="d-flex align-items-baseline">
	                    <div class="h1 mb-3 me-2">{{ total_login }}</div>
	                    <div class="me-auto">
	                        <span v-if="total_login_latest > 0" class="text-yellow d-inline-flex align-items-center lh-1">
	                            +{{ total_login_latest }}   
	                            <svg xmlns="http://www.w3.org/2000/svg" class="icon ms-1" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><line x1="5" y1="12" x2="19" y2="12" /></svg>
	                        </span>
	                    </div>
	                </div>
	            </div>
	        </div>
	    </div>

	    <div v-if="data.isBlockBar" class="col-sm-6 col-lg-3">
	        <div class="card">
	            <div class="card-body">
	                <div class="d-flex align-items-center">
	                    <div class="subheader">Total Users</div>
	                    <div class="ms-auto lh-1">
	                        <div class="dropdown">
	                        	<a class="dropdown-toggle text-muted" href="javascript:void(0)" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
	                        		<span>{{ total_users_label }}</span>
	                        	</a>
	                        	<div class="dropdown-menu dropdown-menu-end">
	                        	    <a :class="getUserTotalactiveClass(1)" href="javascript:void(0)" v-on:click="getUserTotaltoggleActive(1)">All Users</a>
	                        	    <a :class="getUserTotalactiveClass(2)" href="javascript:void(0)" v-on:click="getUserTotaltoggleActive(2)">Last 30 days</a>
	                        	    <a :class="getUserTotalactiveClass(3)" href="javascript:void(0)" v-on:click="getUserTotaltoggleActive(3)">Last 3 months</a>
	                        	</div>
	                        </div>
	                    </div>
	                </div>
	                <div class="d-flex align-items-baseline">
	                    <div class="h1 mb-3 me-2">{{ total_users }}</div>
	                    <div class="me-auto">
	                        <span v-if="total_users_latest > 0" class="text-green d-inline-flex align-items-center lh-1">
	                            +{{ total_users_latest }} 
	                            <svg xmlns="http://www.w3.org/2000/svg" class="icon ms-1" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><polyline points="3 17 9 11 13 15 21 7" /><polyline points="14 7 21 7 21 14" /></svg>
	                        </span>
	                        <span v-else class="text-yellow d-inline-flex align-items-center lh-1">
	                            0 
	                            <svg xmlns="http://www.w3.org/2000/svg" class="icon ms-1" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><line x1="5" y1="12" x2="19" y2="12" /></svg>
	                        </span>
	                    </div>
	                </div>
	            </div>
	        </div>
	    </div>
	</div>

	<div class="row mb-3 row-deck row-cards">
	    <div class="col-6 col-md-6">
	    	<div class="card">
	    		<div class="card-header">
	    			Posts By Week
	    		</div>
	    		<div class="card-body">
	    			<div class="d-flex align-items-center">
	    				<div class="ms-auto lh-1">
	    					<div class="dropdown">
	    						<a class="dropdown-toggle text-muted" href="javascript:void(0)" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
	    							<span>{{ post_week_label }}</span>
	    						</a>
	    						<div class="dropdown-menu dropdown-menu-end">
	    						    <a :class="getPostWeekactiveClass(1)" href="javascript:void(0)" v-on:click="getPostWeektoggleActive(1)">Last 7 days</a>
	    						    <a :class="getPostWeekactiveClass(2)" href="javascript:void(0)" v-on:click="getPostWeektoggleActive(2)">Last 14 days</a>
	    						    <a :class="getPostWeekactiveClass(3)" href="javascript:void(0)" v-on:click="getPostWeektoggleActive(3)">Last 21 days</a>
	    						    <a :class="getPostWeekactiveClass(4)" href="javascript:void(0)" v-on:click="getPostWeektoggleActive(4)">Last 28 days</a>
	    						</div>
	    					</div>
	    				</div>
	    			</div>
	    			<apexchart id="chart1" height="240" type="bar" :options="options1" :series="series1"></apexchart>
	    		</div>
	    		<div class="ribbon ribbon-end ribbon-top">
	    			<svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M12 3v9h9" /><circle cx="12" cy="12" r="9" /></svg>
	    		</div>
	    	</div>
	    </div>

	    <div class="col-6 col-md-6">
	    	<div class="card">
	    		<div class="card-header">
	    			Posts by Month
	    		</div>
	    		<div class="card-body">
	    			<div class="d-flex align-items-center">
	    				<div class="ms-auto lh-1">
	    					<div class="dropdown">
	    						<a class="dropdown-toggle text-muted" href="javascript:void(0)" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
	    							<span>{{ post_month_label }}</span>
	    						</a>
	    						<div class="dropdown-menu dropdown-menu-end">
	    						    <a :class="getPostMonthactiveClass(1)" href="javascript:void(0)" v-on:click="getPostMonthtoggleActive(1)">All Months</a>
	    						    <a :class="getPostMonthactiveClass(2)" href="javascript:void(0)" v-on:click="getPostMonthtoggleActive(2)">January</a>
	    						    <a :class="getPostMonthactiveClass(3)" href="javascript:void(0)" v-on:click="getPostMonthtoggleActive(3)">February</a>
	    						    <a :class="getPostMonthactiveClass(4)" href="javascript:void(0)" v-on:click="getPostMonthtoggleActive(4)">March</a>
	    						    <a :class="getPostMonthactiveClass(5)" href="javascript:void(0)" v-on:click="getPostMonthtoggleActive(5)">April</a>
	    						    <a :class="getPostMonthactiveClass(6)" href="javascript:void(0)" v-on:click="getPostMonthtoggleActive(6)">May</a>
	    						    <a :class="getPostMonthactiveClass(7)" href="javascript:void(0)" v-on:click="getPostMonthtoggleActive(7)">Jun</a>
	    						    <a :class="getPostMonthactiveClass(8)" href="javascript:void(0)" v-on:click="getPostMonthtoggleActive(8)">July</a>
	    						    <a :class="getPostMonthactiveClass(9)" href="javascript:void(0)" v-on:click="getPostMonthtoggleActive(9)">August</a>
	    						    <a :class="getPostMonthactiveClass(10)" href="javascript:void(0)" v-on:click="getPostMonthtoggleActive(10)">Spetember</a>
	    						    <a :class="getPostMonthactiveClass(11)" href="javascript:void(0)" v-on:click="getPostMonthtoggleActive(11)">October</a>
	    						    <a :class="getPostMonthactiveClass(12)" href="javascript:void(0)" v-on:click="getPostMonthtoggleActive(12)">November</a>
	    						    <a :class="getPostMonthactiveClass(13)" href="javascript:void(0)" v-on:click="getPostMonthtoggleActive(13)">December</a>
	    						</div>
	    					</div>
	    				</div>
	    			</div>
	    			<apexchart id="chart2" height="240" type="bar" :options="options2" :series="series2"></apexchart>
	    		</div>
	    		<div class="ribbon ribbon-end ribbon-top">
	    			<svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M11.795 21h-6.795a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v4" /><path d="M18 14v4h4" /><circle cx="18" cy="18" r="4" /><path d="M15 3v4" /><path d="M7 3v4" /><path d="M3 11h16" /></svg>
	    		</div>
	    	</div>
	    </div>
	</div>



	<div class="row row-deck row-cards">		  
	    <div class="col-6 col-md-6">
	    	<div class="card">
	    		<div class="card-header">
	    			Top 10 View Posts
	    		</div>
	    		<div class="card-body">
	    			<table class="table card-table table-vcenter">
	    				<thead>
	    					<tr>
	    						<th>Title</th>
	    						<th>Hits</th>
	    					</tr>
	    				</thead>
	    				<tbody>
	    					<tr v-for="(post, index) in data_tops">
	    						<td><a :href="post.url" target="_blank">{{ post.title }}</a></td>
	    						<td>{{ post.hit }}</td>
	    					</tr>
	    				</tbody>
	    			</table>
	    		</div>
	    	</div>
	    </div>

	    <div v-if="data.isBlockBar" class="col-6 col-md-6">
	    	<div class="card">
	    		<div class="card-header">
	    			Top 10 Less View
	    		</div>
	    		<div class="card-body">
	    			<table class="table card-table table-vcenter">
	    				<thead>
	    					<tr>
	    						<th>Title</th>
	    						<th>Hits</th>
	    					</tr>
	    				</thead>
	    				<tbody>
	    					<tr v-for="(post, index) in data_less">
	    						<td><a :href="post.url" target="_blank">{{ post.title }}</a></td>
	    						<td>{{ post.hit }}</td>
	    					</tr>
	    				</tbody>
	    			</table>
	    		</div>
	    	</div>
	    </div>
	</div>


</div>


</template>

<script>
	import VueApexCharts from 'vue-apexcharts'
	Vue.use(VueApexCharts)
	Vue.component('apexchart', VueApexCharts)

	export default {
        props: ['data'], 
        data() {
        	return {
        		total_posts: 0,
        		total_posts_latest: 0,
        		total_posts_default: 0,
        		total_posts_label: 'All Posts',

        		total_users: 0,
        		total_users_latest: 0,
        		total_users_default: 0,
        		total_users_label: 'All Users',

        		post_week_default: 0,
        		post_week_label: 'Last 7 days',

        		post_month_default: 0,
        		post_month_label: 'All Months',

        		dates: [],
        		options1: {
        		    chart: {
        		        id: 'chart1',
        		        toolbar: {
        		        	show: false,
        		        },
        		    },
        		    xaxis: {
        		        categories: [],
        		    },
        		    tooltip: {
        		        enabled: true,
        		        theme: 'dark',
        		    },
        		},
        		series1: [{
        		    name: 'Total Posts',
        		    data: [],
        		}],

        		series2: [{
        			name: '',
        			data: []
        		}, {
        			name: '',
        			data: []
        		}],
        		options2: {
        			chart: {
        				type: 'bar',
        				height: 350,
        				toolbar: {
        					show: false,
        				},
        			},
        			plotOptions: {
        				bar: {
        					horizontal: false,
        					columnWidth: '55%',
        					endingShape: 'rounded'
        				},
        			},
        			dataLabels: {
        				enabled: false
        			},
        			stroke: {
        				show: true,
        				width: 2,
        				colors: ['transparent']
        			},
        			xaxis: {
        				categories: [],
        			},
        			fill: {
        				opacity: 1
        			},
        			tooltip: {
        				y: {
        					formatter: function (val) {
        						return val;
        					}
        				}
        			}
        		},
        		data_tops: [],
        		data_less: [],

        		total_views: 0,
        		total_views_latest: 0,
        		total_views_default: 0,
        		total_views_label: 'All',

        		total_login: 0,
        		total_login_latest: 0,
        		total_login_default: 0,
        		total_login_label: 'All',

        		total_searches: 0,
        		total_bookmarks: 0,
        		total_sharings: 0,
        		total_downloads: 0,        		
        	};
        },   
        mounted() {
        	this.getChartPosts();
        	this.getTotalViewPosts();
        	this.getTotalLogin();
        	this.getViewPosts();
        	
        }, 
        methods: {
        	getChartPosts() {
        	    axios.get('/api/ajax/dashboard/chart').then(res => {
        	    	this.total_posts = res.data.data.total_posts;
        	    	this.total_posts_latest = res.data.data.total_posts_latest;
        	    	this.total_users = res.data.data.total_users;        	
        	    	this.total_users_latest = res.data.data.total_users_latest;
        	    	this.options1 = {
        	    	    xaxis: {
        	    	        categories: res.data.data.chart_dates,
        	    	    }
        	    	};
        	    	this.series1 = [{
        	    	    data: res.data.data.chart_total,
        	    	}];
        	    	this.options2 = {
        	    	    xaxis: {
        	    	        categories: res.data.data.chart_months,
        	    	    }
        	    	};
        	    	if (res.data.data.total_post_monthly.length) {
        	    		if (res.data.data.total_post_monthly.length > 1) {
			    	    	this.series2 = [{
			    	    		name: res.data.data.total_post_monthly[1].name,
			    	    	    data: res.data.data.total_post_monthly[1].total
			    	    	}, {
				    			name: res.data.data.total_post_monthly[0].name,
				    		    data: res.data.data.total_post_monthly[0].total
			    	    	}];
        	    		}
	        	    	else {
			    	    	this.series2 = [{
			    	    		name: res.data.data.total_post_monthly[0].name,
			    	    	    data: res.data.data.total_post_monthly[0].total
			    	    	}];
	        	    	}
        	    	}
        	    });
        	},
        	getPostTotalactiveClass(segment) {
        		return segment == this.total_posts_default ? 'dropdown-item active' : 'dropdown-item'
        	},
        	getPostTotaltoggleActive(index) {
        		this.total_posts_default = index;
        		if (index == 1) {
        			this.total_posts_label = 'All Posts';
        		}
        		if (index == 2) {
        			this.total_posts_label = 'Last 7 days';
        		}
        		if (index == 3) {
        			this.total_posts_label = 'Last 30 days';
        		}
        		if (index == 4) {
        			this.total_posts_label = 'Last 3 months';
        		}
        		axios.get('/api/ajax/dashboard/total_posts/' + index).then(res => {
        			this.total_posts_latest = 0;
        			this.total_posts = res.data.data.total;
        			this.total_posts_latest = res.data.data.total_latest;
        		});
        	}, 
        	getUserTotalactiveClass(segment) {
        		return segment == this.total_users_default ? 'dropdown-item active' : 'dropdown-item'
        	},
        	getUserTotaltoggleActive(index) {
        		this.total_users_default = index;
        		if (index == 1) {
        			this.total_users_label = 'All Users';
        		}
        		if (index == 2) {
        			this.total_users_label = 'Last 30 days';
        		}
        		if (index == 3) {
        			this.total_users_label = 'Last 3 months';
        		}
        		axios.get('/api/ajax/dashboard/total_users/' + index).then(res => {
        			this.total_users_latest = 0;
        			this.total_users = res.data.data.total;
        			this.total_users_latest = res.data.data.total_latest;
        		});
        	}, 
        	getPostWeekactiveClass(segment) {
        		return segment == this.post_week_default ? 'dropdown-item active' : 'dropdown-item'
        	},
        	getPostWeektoggleActive(index) {
        		this.post_week_default = index;
        		if (index == 1) {
        			this.post_week_label = 'Last 7 days';
        		}
        		if (index == 2) {
        			this.post_week_label = 'Last 14 days';
        		}
        		if (index == 3) {
        			this.post_week_label = 'Last 21 days';
        		}
        		if (index == 4) {
        			this.post_week_label = 'Last 28 days';
        		}
        		axios.get('/api/ajax/dashboard/post_weeks/' + index).then(res => {
        			this.options1 = {
        			    xaxis: {
        			        categories: res.data.data.chart_dates,
        			    }
        			};
        			this.series1 = [{
        			    data: res.data.data.chart_total,
        			}];    
        		});
        	}, 
        	getPostMonthactiveClass(segment) {
        		return segment == this.post_month_default ? 'dropdown-item active' : 'dropdown-item'
        	},
        	getPostMonthtoggleActive(index) {
        		this.post_month_default = index;
        		if (index == 1) {
        			this.post_month_label = 'All Months';
        		}
        		if (index == 2) {
        			this.post_month_label = 'January';
        		}
        		if (index == 3) {
        			this.post_month_label = 'February';
        		}
        		if (index == 4) {
        			this.post_month_label = 'March';
        		}
        		if (index == 5) {
        			this.post_month_label = 'April';
        		}
        		if (index == 6) {
        			this.post_month_label = 'May';
        		}
        		if (index == 7) {
        			this.post_month_label = 'June';
        		}
        		if (index == 8) {
        			this.post_month_label = 'July';
        		}
        		if (index == 9) {
        			this.post_month_label = 'August';
        		}
        		if (index == 10) {
        			this.post_month_label = 'September';
        		}
        		if (index == 11) {
        			this.post_month_label = 'October';
        		}
        		if (index == 12) {
        			this.post_month_label = 'November';
        		}
        		if (index == 13) {
        			this.post_month_label = 'December';
        		}
        		axios.get('/api/ajax/dashboard/post_monthly/' + index).then(res => {
        			this.options2 = {
        			    xaxis: {
        			        categories: res.data.data.chart_months,
        			    }
        			};
        	    	if (res.data.data.total_post_monthly.length > 1) {
		    	    	this.series2 = [{
		    	    		name: res.data.data.total_post_monthly[1].name,
		    	    	    data: res.data.data.total_post_monthly[1].total
		    	    	}, {
			    			name: res.data.data.total_post_monthly[0].name,
			    		    data: res.data.data.total_post_monthly[0].total
		    	    	}];
        	    	}
        	    	else {
		    	    	this.series2 = [{
		    	    		name: res.data.data.total_post_monthly[0].name,
		    	    	    data: res.data.data.total_post_monthly[0].total
		    	    	}];
        	    	}
        		});
        	}, 
        	getViewPosts() {
        		axios.get('/api/ajax/dashboard/post_hits').then(res => {
        			this.data_tops = res.data.data.tops;
        			this.data_less = res.data.data.less;
        		});
        	},
        	getTotalViewPosts() {
        		let index = 1;
        		axios.get('/api/ajax/dashboard/total_views/' + index).then(res => {
        			this.total_views_latest = 0;
        			this.total_views = res.data.data.total_views;
        			this.total_views_latest = res.data.data.total_views_latest;
        		});
        	},
        	getTotalViewactiveClass(segment) {
        		return segment == this.total_views_default ? 'dropdown-item active' : 'dropdown-item'
        	},
        	getTotalViewtoggleActive(index) {
        		this.total_views_default = index;
        		if (index == 1) {
        			this.total_views_label = 'All';
        		}
        		if (index == 2) {
        			this.total_views_label = 'Last 30 days';
        		}
        		if (index == 3) {
        			this.total_views_label = 'Last 3 months';
        		}
        		axios.get('/api/ajax/dashboard/total_views/' + index).then(res => {
        			this.total_views_latest = 0;
        			this.total_views = res.data.data.total_views;
        			this.total_views_latest = res.data.data.total_views_latest;
        		});
        	}, 
        	getTotalLogin() {
        		let index = 1;
        		axios.get('/api/ajax/dashboard/total_login/' + index).then(res => {
        			this.total_login_latest = 0;
        			this.total_login = res.data.data.total_login;
        			this.total_login_latest = res.data.data.total_login_latest;
        		});
        	},
        	getTotalLoginActiveClass(segment) {
        		return segment == this.total_login_default ? 'dropdown-item active' : 'dropdown-item'
        	},
        	getTotalLoginToggleActive(index) {
        		this.total_login_default = index;
        		if (index == 1) {
        			this.total_login_label = 'All';
        		}
        		if (index == 2) {
        			this.total_login_label = 'Last 30 days';
        		}
        		if (index == 3) {
        			this.total_login_label = 'Last 3 months';
        		}
        		axios.get('/api/ajax/dashboard/total_login/' + index).then(res => {
        			this.total_login_latest = 0;
        			this.total_login = res.data.data.total_login;
        			this.total_login_latest = res.data.data.total_login_latest;
        		});
        	}, 
        	getTotalSearches() {
        		axios.get('/api/ajax/dashboard/total_searches').then(res => {
        			this.total_searches = res.data.data.total;
        		});
        	},
        	getTotalBookmarks() {
        		axios.get('/api/ajax/dashboard/total_bookmarks').then(res => {
        			this.total_bookmarks = res.data.data.total;
        		});
        	},
        	getTotalSharing() {
        		axios.get('/api/ajax/dashboard/total_sharings').then(res => {
        			this.total_sharings = res.data.data.total;
        		});
        	},
        	getTotalDownload() {
        		axios.get('/api/ajax/dashboard/total_downloads').then(res => {
        			this.total_downloads = res.data.data.total;
        		});
        	},
        },       
	}
</script>